import * as React from 'react';
import { PortalLocationAutocomplete } from 'components/FormControls';
import { translate } from 'react-i18next';
import * as c from 'models/constants';
import { IStore } from 'redux/IStore';
import {
	setLocationFilter,
	setLocationFilterCoordinates,
	setLocationFilteringStatus,
	setPreviousLocation,
} from 'redux/modules/shop/offices';
import { ISearchGeoCoordinates } from 'models/shop/office';
import { readURLSearchParams } from 'helpers/common';
import { IconName } from 'helpers/renderIcon';
const { connect } = require('react-redux');

interface IProps {
	isAlreadyFiltering?: boolean;
	geoLatitude?: number;
	geoLongidute?: number;
	previousLatitude?: number;
	previousLongitude?: number;
	customIcon?: IconName;
	customIconWidth?: number;
	customIconHeight?: number;
	isLandingPage?: boolean;
	t?: (key: string) => string;
	onChange?: (value: string) => void;

	setLocationFilteringStatus?: (status: boolean) => void;
	setPreviousLocation?: (latitude: number, longitude: number) => void;
	setLocationFilter?: (locationFilter: ISearchGeoCoordinates) => void;
	setLocationFilterCoordinates?: (locationFilter: ISearchGeoCoordinates) => void;
}

@connect(
	(state: IStore) => ({
		isAlreadyFiltering: state.offices?.isFilteringLocation,
		geoLatitude: state.offices?.geoCoordinates?.latitude,
		geoLongidute: state.offices?.geoCoordinates?.longitude,
		previousLatitude: state.offices?.previousGeoCoordinates?.latitude,
		previousLongitude: state.offices?.previousGeoCoordinates?.longitude,
	}),
	(dispatch) => ({
		setLocationFilteringStatus: (status: boolean) => dispatch(setLocationFilteringStatus(status)),
		setPreviousLocation: (latitude: number, longitude: number) => dispatch(setPreviousLocation(latitude, longitude)),
		setLocationFilter: (locationFilter: ISearchGeoCoordinates) => dispatch(setLocationFilter(locationFilter)),
		setLocationFilterCoordinates: (locationFilter: ISearchGeoCoordinates) =>
			dispatch(setLocationFilterCoordinates(locationFilter)),
	}),
)
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class LocationFilter extends React.Component<IProps> {
	constructor(props) {
		super(props);
	}

	componentDidMount() {
		if (readURLSearchParams(c.SHOPS_LOCATION_FILTER_LAT) && readURLSearchParams(c.SHOPS_LOCATION_FILTER_LNG)) {
			const geoCoordinates = {
				latitude: Number(readURLSearchParams(c.SHOPS_LOCATION_FILTER_LAT)),
				longitude: Number(readURLSearchParams(c.SHOPS_LOCATION_FILTER_LNG)),
				distance: c.SALONS_DEFAULT_MAX_DISTANCE,
			};
			this.props?.isLandingPage
				? this.props.setLocationFilterCoordinates(geoCoordinates)
				: this.props.setLocationFilter(geoCoordinates);

			this.props.setLocationFilteringStatus(true);
			if (navigator) {
				navigator.geolocation.getCurrentPosition((x) => {
					this.props.setPreviousLocation(x.coords.latitude, x.coords.longitude);
				});
			} else {
				this.props.setPreviousLocation(
					46.0515128, // 46.0515128 ljubljana coords
					14.5060249, // 14.5060249 ljubljana coords
				);
			}
		}
	}

	render() {
		const {
			onChange,
			t,
			geoLatitude,
			geoLongidute,
			previousLatitude,
			previousLongitude,
			isAlreadyFiltering,
			customIcon,
			customIconWidth,
			customIconHeight,
			setPreviousLocation,
			setLocationFilteringStatus,
			setLocationFilter,
			setLocationFilterCoordinates,
		} = this.props;

		////////////////////////////////////////////////////////////////////////
		// Store changes into redux
		////////////////////////////////////////////////////////////////////////
		const onChangeModified = (value: string | object) => {
			if (value) {
				if (typeof value === 'string') {
					if (onChange) {
						onChange(value);
					}
				}
				if (typeof value === 'object' && value && 'geometry' in value) {
					const lat = (value['geometry'] as any).location?.lat();
					const lng = (value['geometry'] as any).location?.lng();
					const geoCoordinates = { latitude: lat, longitude: lng, distance: c.SALONS_DEFAULT_MAX_DISTANCE };
					if (!isAlreadyFiltering) {
						setPreviousLocation(geoLatitude, geoLongidute);
					}
					setLocationFilteringStatus(true);
					this.props?.isLandingPage ? setLocationFilterCoordinates(geoCoordinates) : setLocationFilter(geoCoordinates);
				}
			} else if (previousLatitude && previousLongitude) {
				const geoCoordinates = {
					latitude: previousLatitude,
					longitude: previousLongitude,
					distance: c.SALONS_DEFAULT_MAX_DISTANCE,
				};
				this.props?.isLandingPage ? setLocationFilterCoordinates(geoCoordinates) : setLocationFilter(geoCoordinates);
				setPreviousLocation(null, null);
				setLocationFilteringStatus(false);
			}
		};
		////////////////////////////////////////////////////////////////////////

		return (
			<>
				<PortalLocationAutocomplete
					input={{
						onChange: onChangeModified,
					}}
					placeholder={t('Shop_ManageShop_Location_Label_SearchLocation')}
					className={c.SHOPS_LOCATION_FILTER}
					iconName={customIcon ? customIcon : 'pin_empty'}
					customSearchTypes={['(cities)']}
					highlightWhenValueSet={true}
					putSelectedValueInUrlQuery={c.SHOPS_LOCATION_FILTER}
					addLatToUrl={c.SHOPS_LOCATION_FILTER_LAT}
					addLngToUrl={c.SHOPS_LOCATION_FILTER_LNG}
					includeDetails={true}
					key={previousLatitude}
					customIconSizeWidth={customIconWidth ? customIconWidth : undefined}
					customIconSizeHeight={customIconHeight ? customIconHeight : undefined}
				/>
			</>
		);
	}
}

export default LocationFilter;
